const initialState = {
  loading: false,
  success: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'FORGOT_PASSWORD_REQUEST': {
      return { ...initialState, loading: true };
    }
    case 'FORGOT_PASSWORD_SUCCESS': {
      return { ...state, success: true, loading: false };
    }
    case 'FORGOT_PASSWORD_FAILURE': {
      return { ...state, error: action.error, loading: false };
    }
    default:
      return state;
  }
}
